<!--components\Boletas\CampoTexto.vue-->
<template>
  <div class="flex flex-col gap-[0.4rem]">
    <p class="text-black text-base font-semibold">
      {{ label }}
      <span v-if="opcional" class="font-normal text-GRIS_BORDES">— opcional</span>
    </p>

    <input
      ref="elRef"
      :type="type"
      :value="modelValue"
      :inputmode="inputmode"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :class="[
        'px-[1rem] text-left w-full text-lg font-bold text-black placeholder:text-gray-300 bg-gray-100 rounded-xl py-[0.5rem] border-gray-300 focus:ring-0 focus:border-ROJO_TITULOS_LEON focus:ring-ROJO_TITULOS_LEON',
        uppercase ? 'uppercase' : '',
      ]"
      @input="$emit('update:modelValue', $event.target.value)"
      @keydown.enter="$emit('keydown-enter', $event)"
    />

    <p v-if="hint" class="text-GRIS_BORDES text-xs">{{ hint }}</p>
  </div>
</template>

<script setup>
import { ref } from "vue";

defineProps({
  label: { type: String, required: true },
  modelValue: { type: String, default: "" },
  type: { type: String, default: "text" },
  inputmode: { type: String, default: null },
  maxlength: { type: [String, Number], default: null },
  placeholder: { type: String, default: "" },
  hint: { type: String, default: "" },
  opcional: { type: Boolean, default: false },
  uppercase: { type: Boolean, default: false },
});

defineEmits(["update:modelValue", "keydown-enter"]);

const elRef = ref(null);
defineExpose({ focus: () => elRef.value?.focus() });
</script>